<textarea #richEditorDiv style="visibility: hidden"></textarea>

<ng-container *ngIf="!editorIsReady">
  <div class="loading-screen">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</ng-container>
